import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrl } from '../../../shared/models/apiurl.models';
import { ApiService } from '../../services/api.service';
import { ApiResponse } from '../../models/api-response.model';
import { Page, PageItem } from '../../models/page.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  set items(value: PageItem[]) {
    this._items.next(value);
  }

  private readonly _items: BehaviorSubject<PageItem[]> =
    new BehaviorSubject<PageItem[]>([]);

  get items$(): Observable<PageItem[]> {
    return this._items.asObservable();
  }

  updateItems(items: PageItem[]): void {
    this._items.next(items);
  }

  constructor(private http: HttpClient, private apiUrl: ApiUrl, private apiService: ApiService) {

  }

  getPages(categoryId:number): Observable<ApiResponse<Page[]>> {
    if(categoryId == 0 ){
      return this.apiService.get(`api/pages/`)
    }
    return this.apiService.get(`api/pages/?category=${categoryId}`)
  }

  getPageById(pageId:number): Observable<ApiResponse<Page[]>> {
    return this.apiService.get(`api/pages/${pageId}/`)
  }

  create(form:any): Observable<ApiResponse<Page[]>> {
    return this.apiService.post('api/pages/', form)
  }

  update(form:any, id:number): Observable<ApiResponse<Page[]>> {
    return this.apiService.put(`api/pages/${id}/`, form)
  }

  delete(id:number): Observable<ApiResponse<Page[]>> {
    return this.apiService.delete(`api/pages/${id}/`)
  }
}
